import React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../../../store/store";

/**
 * Shows the organisation logo pulled from the currently signed-in user
 * (`state.currentUser.data.orgLogo`). Sized to fit the 64px header.
 */
const OrgLogo: React.FC = () => {
  const { data } = useSelector((state: RootState) => state.currentUser);

  const logoUrl = (
    orgLogo: string | string[] | undefined
  ): string | undefined => {
    if (!orgLogo) return undefined;
    if (typeof orgLogo === "string") return orgLogo;
    if (Array.isArray(orgLogo) && orgLogo.length > 0) return orgLogo[0];
    return undefined;
  };

  const src = logoUrl(data?.orgLogo);
  if (!src) return null;

  return (
    <img
      src={src}
      alt=""
      style={{
        height: 36,
        maxWidth: 160,
        width: "auto",
        objectFit: "contain",
        display: "block",
      }}
    />
  );
};

export default OrgLogo;
